<template>
  <div
    v-if="showCommentsToggle"
    class="comments-toggle"
  >
    <v-btn
      variant="outlined"
      min-width="48"
      width="48"
      class="comments-icon"
      :active="currentTab === 'comments'"
      @click="setCurrentTab('comments')"
    >
      <DpplSvg file-name="icons/Icon_Comment" />
    </v-btn>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useCommenting } from '@/stores/commenting/commenting';
import { useDocumentRightPanel } from '@/stores/document/rightPanel';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

const rightPanelStore = useDocumentRightPanel();
const commentingStore = useCommenting();
const { currentTab } = storeToRefs(rightPanelStore);
const { setCurrentTab } = rightPanelStore;

const showCommentsToggle = computed(() => commentingStore.showCommentsToggle);
</script>

<style lang="less" scoped>
.comments-icon {
  border-color: @stroke-default;
  svg {
    color: @icon-default;
  }
}
</style>
